/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-06-20",
    versionChannel: "nightly",
    buildDate: "2024-06-20T00:05:30.479Z",
    commitHash: "c16b03f010a6dae4786ee0ea0e4c77c2411507a1",
};
